export var State;
(function (State) {
    function copy(state) {
        return {
            value: state.value,
            selection: { start: state.selection.start, end: state.selection.end, direction: state.selection.direction },
            remainder: state.remainder,
        };
    }
    State.copy = copy;
})(State || (State = {}));
//# sourceMappingURL=State.js.map